import styled from "styled-components";

const WSBottomContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin-top: auto;
  padding: 12px 0 10px;
  border-top: 1px solid ${props => props.theme.colors.frameGrey};
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 -6px 12px rgba(17, 24, 39, 0.08);
`;
export default WSBottomContainer;
